import { redirect, type LoaderFunctionArgs } from 'react-router-dom'
import DraftsPage from '@/drafting/destination/components/DraftsPage'
import { isDraftsDestinationEnabled } from '@/drafting/destination/drafts-destination-flag'
import { kMattersRoute } from '@/matter/constants'
import { kRouteSegments, matterPaths } from '@/routing/paths'
import type { RouteFactory } from '@/routing/types'

/** Sends a flag-off deep link to the matter it named, whose own guards handle access from there. */
function redirectToMatterOverview({ params }: LoaderFunctionArgs): Response {
  return redirect(params.matterId ? matterPaths.overview(params.matterId) : kMattersRoute)
}

/**
 * Creates the Drafts destination route for nesting under MatterLayout.
 * URL pattern: /dashboard/m/:matterId/drafts
 *
 * While the destination is disabled the path stays registered but redirects to the matter's
 * overview, so a shared or bookmarked deep link lands somewhere real instead of on a blank or
 * half-enabled destination. The redirect runs in the loader, before the page mounts, so none of the
 * destination's hooks — and none of their requests or analytics — run with the flag off.
 *
 * @see isDraftsDestinationEnabled for the flag combinations the destination supports
 * @see MatterLayout for parent route context
 */
export const createDraftsChildRoutes: RouteFactory = () => {
  if (!isDraftsDestinationEnabled()) return [{ path: kRouteSegments.drafts, loader: redirectToMatterOverview }]

  return [{ path: kRouteSegments.drafts, element: <DraftsPage /> }]
}
